import angular from 'angular';
import { get, isEmpty } from 'lodash';

const module = angular.module('whyline.modals.auto-call-reason', []);

const AutoCallReasonController = ($scope, $uibModalInstance, $timeout, currentOrganization) => {
    'ngInject';

    $scope.counter;

    $scope.init = () => {
        $scope.counter = $timeout(() => {
            $scope.cancel('timeout');
        }, 30000);
    };

    $scope.selectedReason;

    $scope.blockSaveButton = true;

    $scope.pausedReasons = get(currentOrganization.configuration, 'pausedReasons', []);

    $scope.changeSelectedReason = selectedReason => {
        $scope.selectedReason = selectedReason;

        $scope.blockSaveButton = (!isEmpty(selectedReason)) ? false : true;
    }

    const validate = () => {
        if (isEmpty($scope.selectedReason)) {
            return false;
        }
    
        return true;
    };

    $scope.save = () => {
        if (validate()) {
            $timeout.cancel($scope.counter);

            $uibModalInstance.close($scope.selectedReason);
        }
    };

    $scope.cancel = (closeMotive) => {
        if (!closeMotive) {
            closeMotive = 'cancel';
        }

        $timeout.cancel($scope.counter);

        $uibModalInstance.close(closeMotive);
    };

    $scope.init();
}

module.exports = module.controller('AutoCallReasonController', AutoCallReasonController);